<template>
  <v-content class="grey lighten-4">
    <v-toolbar flat class="blue-grey lighten-4 elevation-2">
      <v-toolbar-title>Impostos</v-toolbar-title>
    </v-toolbar>

    <v-layout row wrap justify-center>
      <v-flex pa-2>
        <v-text-field 
        :disabled="!ehContabilidade"
        label="IRPJ" 
        @blur="formataImpostos($event, 'irpj')"
        v-model="impostos.irpj"></v-text-field>
      </v-flex>

      <v-flex pa-2>
        <v-text-field 
        :disabled="!ehContabilidade"
        @blur="formataImpostos($event, 'iss')" 
        label="ISS" 
        v-model="impostos.iss"></v-text-field>
      </v-flex>

      <v-flex pa-2>
        <v-text-field
          :disabled="!ehContabilidade"
          @blur="formataImpostos($event, 'cofins')"
          label="COFINS"
          v-model="impostos.cofins"
        ></v-text-field>
      </v-flex>

      <v-flex pa-2>
        <v-text-field
        :disabled="!ehContabilidade"
        @blur="formataImpostos($event, 'pis')" 
        label="PIS" 
        v-model="impostos.pis"></v-text-field>
      </v-flex>

      <v-flex pa-2>
        <v-text-field
        :disabled="!ehContabilidade"
        @blur="formataImpostos($event, 'inss')" 
        label="INSS" 
        v-model="impostos.inss"></v-text-field>
      </v-flex>

      <v-flex pa-2>
        <v-text-field 
        :disabled="!ehContabilidade"
        @blur="formataImpostos($event, 'csll')" 
        label="CSLL" 
        v-model="impostos.csll"></v-text-field>
      </v-flex>

      <v-flex pa-2>
        <v-text-field
          :disabled="!ehContabilidade"
          @blur="formataImpostos($event, 'ajuste')"
          label="AJUSTE"
          v-model="impostos.ajuste"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap justify-center>
      <v-flex pa-2>
        <v-text-field
         :readonly="true"
         :value="calculaImposto('liquido')" 
         label="Valor Líquido"></v-text-field>
      </v-flex>

      <v-flex pa-2>
        <v-text-field 
        :readonly="true"
        :value="calculaImposto('somaImpostos')" 
        label="Total Impostos"></v-text-field>
      </v-flex>

      <v-flex pa-2>
        <v-text-field 
        :readonly="true"
        :value="valorTotal" 
        label="Valor Bruto"></v-text-field>
      </v-flex>
    </v-layout>
  </v-content>
</template>
<script>
import moedasMixins from '@/mixins/moedasMixin'

export default {
  mixins: [moedasMixins],
  props: {
    impostos: {
      type: Object
    },
    tipoDeMoeda: {
      type: String,
      default: 'BRL'
    },
    ehContabilidade: {
      type: Boolean,
      default: false
    },
    valorTotal: {
      type: String,
      default: ''
    }
  },
  methods: {
    formataImpostos(event, propriedade){
      let numeroNegativo = false;
      if(event.target.value.indexOf('-') != -1){
        numeroNegativo = true;
        event.target.value = event.target.value.replace('-','');
      } 
      let valor = this.converterParaMoedaReal(
        this.converterValorStringEmNumero(event.target.value, this.tipoDeMoeda), this.tipoDeMoeda
      )
      if(numeroNegativo) valor = '-' + valor;
      this.$emit('recebeImpostos', 
      {propriedade, valor}
      );      
    },
    calculaImposto(tipo){
      let calculo = 0;
      let valorTotal = Number(this.converterValorStringEmNumero(this.valorTotal, this.tipoDeMoeda));
      let somaImpostos = 0;
      let valorParaRetornar = 0;
      
      Object.keys(this.impostos).map(i => {
        let numeroNegativo = false;
        let valor = this.impostos[i];

        if(valor.indexOf('-') != -1 && valor.length == 1) {
          valor = '0';
        }

        if(valor.indexOf('-') != -1){
          numeroNegativo = true;
          valor = valor.replace('-', '').replace(/\s/g, '');
          valor = this.converterValorStringEmNumero(valor, this.tipoDeMoeda);
          valor = '-' + valor;
          valor = Number(valor);
        } else {
          valor = Number(this.converterValorStringEmNumero(valor, this.tipoDeMoeda))
        }

        if(i == 'ajuste') {
          somaImpostos -= valor;
        }
        else somaImpostos += valor;
      })

      calculo = valorTotal - somaImpostos;

      if(tipo == 'somaImpostos') valorParaRetornar = somaImpostos;
      else valorParaRetornar = calculo;
      
      valorParaRetornar = this.converterParaMoedaReal(
        this.converterValorStringEmNumero(valorParaRetornar, this.tipoDeMoeda), this.tipoDeMoeda
      );
      return valorParaRetornar;
      
    }
  },
  computed: {

  },
  mounted(){
    /*
     let valorZerado = {
        target: {
          value: 0
        }
      }
      Object.keys(this.impostos).map(i => this.formataImpostos(valorZerado, i));
      */
  },
};
</script>
<style scoped>
.flex {
  padding: 16px;
}
</style>